import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '影片分类', to: '/category' },
  { label: '影评专题', to: '/special' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setSearchOpen(false);
    setMenuOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-clapperboard-line text-xl" />
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950 whitespace-nowrap">美国伦理片</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-3.5 py-2 text-sm font-medium rounded-md text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            onClick={() => setSearchOpen((v) => !v)}
            className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg" />
          </button>
          <Link
            to="/category"
            className="px-4 py-2 text-sm font-medium rounded-md bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始浏览影片
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          aria-label="菜单"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
        </button>
      </div>

      {searchOpen && (
        <div className="hidden md:block border-t border-background-200 bg-background-50 animate-fade-in">
          <form onSubmit={submitSearch} className="flex items-center gap-2 px-8 py-3">
            <i className="ri-search-line text-lg text-foreground-500" />
            <input
              autoFocus
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影片名称或影评关键词，回车开始检索…"
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button type="submit" className="px-4 py-1.5 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              检索
            </button>
          </form>
        </div>
      )}

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <form onSubmit={submitSearch} className="flex items-center gap-2 px-4 pt-3 pb-1">
            <i className="ri-search-line text-lg text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影片或影评…"
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none py-2"
            />
          </form>
          <nav className="flex flex-col px-2 py-2">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-3 text-sm font-medium rounded-md text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/category"
              onClick={() => setMenuOpen(false)}
              className="mt-2 px-3 py-3 text-sm font-medium rounded-md bg-accent-500 text-background-50 text-center cursor-pointer"
            >
              开始浏览影片
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}